import {MonitoringService, WebService} from '.';
import {CustomerProfileStore} from '../store';
import {set, query} from 'vue-gtag';
import {Platform} from 'quasar';

class Analytics {
	async init() {
		set({
			dimension1: await WebService.getDomain(),
			dimension2: process.env.VUE_APP_VERSION as string,
		});
		MonitoringService.setTag('domain', await WebService.getDomain());
		MonitoringService.setTag('apiHost', WebService.host);
		MonitoringService.setTag('isCapacitor', Platform.is.capacitor);
	}

	login() {
		if(CustomerProfileStore.customerProfile) {
			// Not sure which of these two we need so I'm doing both
			query('config', 'GA_MEASUREMENT_ID', {
				user_id: CustomerProfileStore.customerProfile.id
			});
			set({
				user_id: CustomerProfileStore.customerProfile.id
			});
			MonitoringService.setUser({
				id: CustomerProfileStore.customerProfile.id
			});
		}
	}

	logout() {
		query('config', 'GA_MEASUREMENT_ID', {
			user_id: 'anonymous'
		});
		set({
			user_id: 'anonymous'
		});
		MonitoringService.setUser(null);
	}
}



export const AnalyticsService = new Analytics();
